import React from 'react';
import {observer} from "mobx-react";
import {useServices} from '../../../../../../react-hooks/use-services.hook';
import {FlexGrowItemBox} from '../../../../../../themes/architecture/css-helpers/flex';
import {VideoSlideFilterButtonBox} from "./video-slide-filter-button.box";
import {VideoSlideFilterButtonIconBox} from "./video-slide-filter-button-icon.box";
import {ISvgIconProps} from "../../../../../../basic-ui-components/icon/svg-icon/svg.icon";
import {Check} from "@sparkware/app-utils";

interface VideoSlidesHeaderFilterButtonComponentProps {
 textTranslationKey: string;
 isActive?: boolean;
 icon?: React.ComponentType<ISvgIconProps>;
 onClick: (activeFilterTranslationKey: string) => void;
}

export const VideoSlidesHeaderFilterButtonComponent: React.FC<VideoSlidesHeaderFilterButtonComponentProps> = observer((props) => {
    const services = useServices();

    const renderIcon = () => {
        if(Check.isEmpty(props.icon)) {
            return null;
        }

        let Icon = props.icon;
        let iconStyle: React.CSSProperties = props.isActive ? {color: services.theme.currentTheme.colors.brandPrimary} : {};
        return (
            <VideoSlideFilterButtonIconBox>
                <Icon size={3} style={iconStyle}/>
            </VideoSlideFilterButtonIconBox>
        );
    };

    return (
        <FlexGrowItemBox>
            <VideoSlideFilterButtonBox isActive={Boolean(props.isActive)} onClick={() => props.onClick(props.textTranslationKey)}>
                    {renderIcon()}
                {services.translation.translate(props.textTranslationKey)}
            </VideoSlideFilterButtonBox>
        </FlexGrowItemBox>
    );
})